import { AppHeader } from '@shared/ui/app-header'
import { Button } from '@shared/ui/button'
import { motion } from 'motion/react'

interface LandingViewProps {
  readonly onStart: () => void
}

export function LandingView({ onStart }: LandingViewProps) {
  return (
    <div className="relative flex min-h-dvh flex-col overflow-hidden @container">
      {/* Header */}
      <AppHeader variant="transparent" trailing={<AppHeader.Menu />} />

      {/* Character Image -- fullscreen background */}
      <motion.div
        className="pointer-events-none absolute inset-0 z-0"
        style={{
          maskImage:
            'linear-gradient(to top, transparent 0%, black 15%, black 85%, transparent 100%)',
          WebkitMaskImage:
            'linear-gradient(to top, transparent 0%, black 15%, black 85%, transparent 100%)',
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <motion.img
          src="/character-assets/1_landing_cleaned.png"
          alt=""
          aria-hidden="true"
          className="h-full w-full object-cover object-top will-change-transform"
          initial={{ scale: 1.08 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.2, type: 'spring', bounce: 0 }}
        />
        {/* L1: Dimming overlay */}
        <div className="absolute inset-0" style={{ backgroundColor: 'var(--hero-overlay)' }} />
      </motion.div>

      {/* L2: Top veil gradient */}
      <div
        className="pointer-events-none absolute inset-x-0 top-0 z-[1] h-[40%]"
        style={{
          background:
            'linear-gradient(to bottom, var(--hero-veil-from) 0%, var(--hero-veil-from) 40%, var(--hero-veil-to) 100%)',
        }}
      />

      {/* Top Text */}
      <div className="relative z-[2] px-6 pt-2 text-center">
        <motion.h1
          className="typo-hero font-extrabold text-foreground"
          style={{ textShadow: 'var(--hero-text-shadow)' }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          당신의 운명을
          <br />
          풀어드리겠습니다
        </motion.h1>
        <motion.p
          className="mt-1 typo-label text-foreground/70"
          style={{ textShadow: 'var(--hero-text-shadow)', fontWeight: 500 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          사주 명리학으로 읽는
          <br />
          나만의 인생 해석서
        </motion.p>
      </div>

      <div className="flex-1" />

      {/* Sticky bottom CTA */}
      <motion.div
        className="sticky bottom-0 z-[2] flex flex-col items-center px-6 pb-8 pt-16"
        style={{
          background: 'linear-gradient(to top, hsl(var(--bg-base)) 60%, transparent 100%)',
        }}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.3 }}
      >
        <Button
          type="button"
          variant="cta"
          size="xl"
          className="w-full max-w-[320px]"
          onClick={onStart}
        >
          내 사주 무료로 확인하기
        </Button>
        <p className="mt-3 text-center typo-footnote text-muted-foreground/60">3분이면 충분해요</p>
      </motion.div>
    </div>
  )
}
